import i18n from '../i18n';

export const formatBedDisplayName = (
  bedName?: string | null,
  anchorCode?: string | null,
  fallbackId?: string | number | null,
): string => {
  const raw = typeof bedName === 'string' ? bedName.trim() : '';
  const auto = raw.match(/^(?:(?:Bed|Грядка|Bancal)\s+)?([AC]\d+[BD]\d+)$/i);
  const custom = auto ? auto[1].toUpperCase() : raw;
  const anchor = typeof anchorCode === 'string' ? anchorCode.trim() : '';

  if (custom && anchor) {
    // Не дублируем дефолтный формат, если имя не меняли.
    const defaultName = i18n.t('planning:bedName.withAnchor', { anchor });
    if (custom === defaultName || custom === anchor) {
      return anchor;
    }
    return `${custom} [${anchor}]`;
  }

  if (custom) return custom;
  if (anchor) return anchor;

  if (fallbackId !== undefined && fallbackId !== null) {
    return i18n.t('planning:bedName.withId', { id: String(fallbackId).slice(0, 8) });
  }

  return i18n.t('planning:bedName.unknown');
};
